var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:#2c2c2c;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 32,
    transform: "translate(947 66)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-947 -66)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(950.5 70)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5 2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6.463,17.228a25.84,25.84,0,0,1,4.046,0c.427.1.89.329.89.833a1.557,1.557,0,0,1-.695,1.174,3.634,3.634,0,0,1-1.713.731,3.793,3.793,0,0,1-1.008,0,3.618,3.618,0,0,1-1.713-.732,1.552,1.552,0,0,1-.7-1.173C5.574,17.557,6.036,17.327,6.463,17.228ZM8.545,0a7.041,7.041,0,0,1,5.467,2.625A5.544,5.544,0,0,1,15.207,6.37h0V6.8A3.887,3.887,0,0,0,16.27,9.646a3.362,3.362,0,0,1,.73,2.31,3.615,3.615,0,0,1-.863,2.378,4.537,4.537,0,0,1-2.9,1.413c-1.571.134-3.144.247-4.737.247a41.645,41.645,0,0,1-4.737-.247,4.532,4.532,0,0,1-2.9-1.413A3.616,3.616,0,0,1,0,11.956a3.367,3.367,0,0,1,.73-2.31A3.8,3.8,0,0,0,1.794,6.8h0V6.37A5.627,5.627,0,0,1,3.077,2.512,7.074,7.074,0,0,1,8.456,0h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.6417fbeed1901dab169ef433e53861be.svg";
export { ForwardRef as ReactComponent };